module.exports = __webpack_public_path__ + "assets-cabinet/img/logout-icon.b8386845.svg";